import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController, ModalController, NavController, Platform, ToastController, IonRange } from '@ionic/angular';
import { FileUploadService } from 'src/providers/upload';
import { DomSanitizer } from "@angular/platform-browser";
import { ServicesProvider } from 'src/providers/services';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { Media, MediaObject } from '@ionic-native/media/ngx';
import { File } from '@ionic-native/file/ngx';
import { HttpClient, HttpEventType } from "@angular/common/http";
import { SelectProgramPage } from './select-program/select-program.page';
import { AddCall } from 'src/providers/addvCall';
declare var cordova: any;

@Component({
  selector: 'app-chat',
  templateUrl: './chat.page.html',
  styleUrls: ['./chat.page.scss'],
  
})

export class ChatPage implements OnInit {

  @ViewChild('audioElement') audioElementRef: ElementRef;
  @ViewChild('waveformContainer') waveformContainerRef: ElementRef;
  @ViewChild('timeline') timelineRef: IonRange;
  @ViewChild('waveformCanvas') waveformCanvas: ElementRef;

  currentTime: number = 0;
  fileList = [];
  presentView: string;
  headerValue: string;
  backValue: string;
  uploadPic: any = [];
  getModule: any;
  getRemark: any;
  getScreenName: any;
  storeListModule: any=[];
  patientBasicDetails: any;
  ticketList: any = [];
  EmptyData: any;
  audioList: any[] = [];
  recordFilePath: any;
  record: any;  
  chunks: [];
  recorder = null;
  audioElement = null;
  startButton = null;
  stopButton = null;
  aud: any;

ms : any = '0' + 0;
sec : any = '0' + 0;
min : any = '0' + 0;
hrs : any = '0' + 0;
startTimer  : any;
running = false;
audiodata:any;
audiopathdata:any;
  audio : MediaObject;
  showIcon: boolean = false;
  fileName: any;
  filePath: any;
  isClicked1: any;
  isClicked2: any;
  tickSts: any;
  resolved: any;
  moduleId: any;
  moduleName: any;
  ticketStatusOne: any;
  ticketStatusTwo: any;
  ticketStatusThree: any;
  ticketStatusFour: any;
  programimage : any = [
  'assets/newIcons/doctor-img.svg',
  'assets/newIcons/labs.svg',
  'assets/newIcons/reports.svg',
  'assets/newIcons/nursing.svg',
  'assets/newIcons/trainer.svg',
  'assets/newIcons/sports acadamy.svg',
  'assets/newIcons/dietplan.svg',
  'assets/newIcons/pharmacy.svg',
  'assets/newIcons/bed_icons.svg',
  'assets/newIcons/physiotheraphys.svg',
  'assets/newIcons/physiotheraphys.svg'];
  PatientProfileImage: any;
  audioblob: any;
  uploadProgressaudio: any;
  loaderpercentage: any;
  uploadProgress: any;
  resolutiontxt: any;
  audioStart:any = false;
  isDisable : boolean;
  isDisableAudio : boolean;

  constructor(
    public router: Router,
    public http: HttpClient,
    public services: ServicesProvider,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public fileupload: FileUploadService,
    public toastCtrl: ToastController,
    private sanitizer: DomSanitizer,
    private media: Media,
    private file: File,
    public navCtrl: NavController,
    public platform: Platform,
    public addCall: AddCall,
    private cdr: ChangeDetectorRef,
  ) { }



   
starttime():void {
if(!this.running){
  this.running=true;
  this.startTimer = setInterval(()=>{
    this.ms++;
    this.ms = this.ms < 10 ? '0' + this.ms : this.ms;
    
    if(this.ms === 100){
      this.sec++;
      this.sec = this.sec < 10 ? '0' + this.sec : this.sec;
      this.ms = '0' + 0;
    }
    if(this.sec === 60){
      this.min++;
      this.min = this.min < 10 ? '0' + this.min : this.min;
      this.sec = '0' + 0;
    }
    if(this.min === 60){
      this.hrs++;
      this.hrs = this.hrs < 10 ? '0' + this.hrs : this.hrs;
      this.min = '0' + 0;
    }
  },10)
}
}

stoptime():void{
  clearInterval(this.startTimer)
  this.running = false;
}
reset():void{
  clearInterval(this.startTimer)
  this.running = false;
  this.hrs = this.min = this.sec = this.ms = '0' + 0 ;
}

  ngOnInit() {
    this.uploadPic = JSON.stringify(['/shops/gokul Bakery/1606371552447.jpeg', '/shops/gokul Bakery/1606371552456.jpeg', '/shops/gokul Bakery/1606371552457.jpeg']);
    console.log("gd", this.uploadPic);
  }

async presentToast(tostMsg) {
    const toast = await this.toastCtrl.create({
      message: tostMsg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  //---------------\/--------------PRE DEFINED FUNCTION'S------------------\/---------------------//

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }
  async AlertInfos(msg,ticket, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        'msgdata': msg,
        'ticket': ticket,
        'sts': status,
      }
    });
    await alert.present();
  }
  doRefresh(event) {
    console.log("event=>", event);
    this.ticketList = [];
    this.getTicketList();

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  //---------------/\--------------PRE DEFINED FUNCTION'S------------------/\----------------------//
  isAndroid: any = null;
  isIos: any = null;
  ionViewWillEnter() {
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is("ios")) {
      this.isIos = 1
    } else if (this.platform.is("android")) {
      this.isAndroid = 1
    }
    this.audioStart = false;
    this.presentView = "listAskdReportsPage";
    this.backValue = "goHome";
    this.headerValue = this.addCall.title553;
    this.EmptyData = "";
    this.isClicked1 = -1;
    this.isClicked2 = -1;
    this.tickSts = "";
    this.ticketStatusOne=""
    this.ticketStatusTwo=""
    this.ticketStatusThree=""
    this.ticketStatusFour=""
    this.audiofile = "";
    this.uploadProgressaudio = 0;
    this.uploadProgress = 0;
    this.PatientProfileImage = "";
    this.getModule = "";
    this.getScreenName = "";
    this.getRemark = "";
    this.fileList = [];
    this.showIcon = false;
    this.reset();
    this.getPatientBasicDetails();
    this.isDisable = true;
    this.isDisableAudio = true;
    this.services.postRequestGndrl("sales/getvendortype", "").subscribe((res) => {
      console.log("ModuleList=>", res);
      for (let i= 0 ; i < res.data.length; i++ ){
        this.storeListModule.push({
          name : res.data[i].vendor_type,
          id:res.data[i].id,
          image : this.programimage[i]})
      }
      console.log(this.storeListModule);
      
    });
  };

  ionViewWillLeave(){
      this.storeListModule = [];   
  }

  async getTicketList() {
    
    let apiData = JSON.stringify({
      "ticket_raiser_email": localStorage.getItem("Email")
    });
    this.services.postRequestGndrl("admin/admingetticketinglistbyemailid", apiData).subscribe((res) => {
      
      console.log("listTicket", res);
      this.EmptyData = res.status;
      this.ticketList = res.data;
      for(let i =0; i<=res.data.length;i++){
        if (res.data[i].ticket_status == "Resolved") {
          this.ticketStatusOne = 'Resolved'
        }  else if(res.data[i].ticket_status == 'Pending'){
          this.ticketStatusTwo = 'Pending'
        } else if (res.data[i].ticket_status == 'Reopen') {
          this.ticketStatusThree = 'Reopen'
        } else if(res.data[i].ticket_status == 'Completed'){
          this.ticketStatusFour = 'Closed'
        } 
      }
    });
  }

  openReportUploadPage() {
    this.resolved = "N";
    this.presentView = "reportUploadPage";
    this.backValue = "goListPage";
    this.headerValue = this.addCall.title553;
    this.getModule = "";
    this.getScreenName = "";
    this.getRemark = "";
    this.fileList = [];
    this.audiofile = "";
    this.audiodata = "";
    this.audiopathdata = "";
    this.uploadProgress = 0;
    this.PatientProfileImage = "";
    this.uploadProgressaudio = 0;
  }

  getPatientBasicDetails() {
    
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "currentTime": new Date().toTimeString().split(" ")[0]
    });
    console.log("send patient Basic Reqst=>", JSON.parse(apiData));
    this.services.postRequest("getPatientProfile", apiData).subscribe(res => {
      console.log(res);
      this.patientBasicDetails = res.data[0];
      this.getTicketList();
    });
  }

  makeResolve(i, res, modName, scrName, remark, tNO, resolutiontext) {
    this.resolved = "Y";
    this.isClicked1 = i;
    this.getModule = modName;
    this.getScreenName = scrName;
    this.getRemark = remark;
    this.tickSts = "RES";
    this.resolutiontxt = resolutiontext;
    this.insertUpdateTick(tNO, "resolve");
  }
  makeReopen(i, res, modName, scrName, remark, tNO, resolutiontext) {
    this.resolved = "N";
    this.isClicked2 = i;
    this.getModule = modName;
    this.getScreenName = scrName;
    this.getRemark = remark;
    this.tickSts = "RO";
    this.resolutiontxt = resolutiontext;
    this.insertUpdateTick(tNO, "reopen");
  }

  async addReport() {
    
    console.log(this.getModule)
    if (!this.getModule) {
      this.presentToast(this.addCall.title549);
    } 
    else if ((this.fileList.length == 0) && (this.audiodata == 0) && (!this.getRemark)) {
      this.presentToast("Upload Either Audio or Document or Remarks");
    } else if (this.audioStart == true) {
      this.presentToast("Please close the Audio");
    } else {
      this.insertUpdateTick("", "add");
    }
  }

  async insertUpdateTick(tNO, from) {
    
    if (from == "resolve"){
     this.resolutiontxt = this.resolutiontxt;
    }else if (from == "reopen"){
      this.resolutiontxt = this.resolutiontxt;
    }else{
      this.resolutiontxt = "";
    }
    console.log("getModule=>", this.getModule);
     this.moduleName = this.getModule.selectprogramname;
     this.moduleId = this.getModule.selectId;
    if (this.tickSts == "RES" || this.tickSts == "RO") {
      for (let item of this.storeListModule) {
        if (this.getModule == item.name) {
          this.moduleId = item.id;
        }
      }
      this.moduleName = this.getModule;
    } else {
      this.tickSts = "P"
    }
    console.log("MN=>", this.moduleName);
    console.log("MI=>", this.moduleId);

    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
    });
    await loading.present();
  
    let apiData = JSON.stringify({
      "ticket_number": tNO,
      "ticket_description": this.getRemark,
      "ticket_status": this.tickSts,
      "ticket_raiser_email": this.patientBasicDetails.email,
      "ticket_raiser_mobile_number": this.patientBasicDetails.phone_no,
      "c_user": localStorage.getItem("patient_id"),
      "resolved": this.resolved,
      "appname": "member",
      "app_user_id": "1",
      "vendor_type": this.moduleId,
      "module_name": this.moduleName,
      "screen_name": this.getScreenName,
      "pics":  JSON.stringify(this.fileList),
      "audio": this.audiopathdata,
      "resolution": this.resolutiontxt,
      "ticket_type": ""
    });

    this.services.postRequestGndrl("admin/insertupdateticket", apiData).subscribe(async res => {
      console.log("response=>", res);
      this.isClicked1 = -1;
      this.isClicked2 = -1;
      this.tickSts = "";
      await loading.dismiss();
      setTimeout(() => {
        this.loadingController.dismiss();
      }, 500);
      if (res.status == 1) { 
        if (from == "add") {
          let data = res.data[0].v_return_msg.split("<br>");
          let messageData = data[0] ;
          let messageDataTicket = data[1] ;
          console.log("mess1",messageData);
          console.log("mess2",messageDataTicket);
          if(this.addCall.selectedLanguage == 'en'){
            this.AlertInfos(messageData, messageDataTicket,res.status);
          }else if(this.addCall.selectedLanguage == 'ea' && messageData == "Ticket added successfully! "){
            let arabData = messageData == "Ticket added successfully! " ? ".تم إرسال الشكوى بنجاح" : messageData;
            let arabDataTicket = "." + res.data[0].v_return_value + " " + "رقم الشكوى"
            this.AlertInfos(arabData, arabDataTicket,res.status);
          }
         
        } else if (from == "reopen") {
          this.AlertInfo(this.addCall.title587, 93);
        } else if (from == "resolve") {
          this.AlertInfo(this.addCall.title588, res.status);
        }
        this.presentView = "listAskdReportsPage";
        this.backValue = "goHome";
        this.headerValue = this.addCall.title553;
        this.EmptyData = null;
        this.ticketList = [];
        this.getTicketList();
      }
      else {
        this.AlertInfo(res.data[0].v_return_msg, res.status);
      }
    });
  
  }


 async startRec() {
    if (this.platform.is("android")) {
       const hasPermission = await this.checkAudioPermission();
        if (hasPermission) {
           debugger;
           this.audiofile = "";
           this.audiodata = "";
           this.audiopathdata = "";
           this.uploadProgressaudio = 0;
           console.log('Audio permission granted');
           this.audioStart = true;
           this.fileName = new Date().getTime();
           this.recordFilePath = this.file.externalDataDirectory + `${this.fileName}.mp3`;
           this.record = this.media.create(this.recordFilePath);
           this.record.startRecord();
           this.showIcon = true;
           this.starttime();
           console.log("Record Start\"android\"");
        } else {
          this.presentToast('Permission denied for media recording.');
          console.log('Audio permission denied');
        }
    }else if (this.platform.is("ios")) {
           const hasPermission = await this.checkAudioPermission();
          if (hasPermission) {
             debugger;
             this.audiofile = "";
             this.audiodata = "";
             this.audiopathdata = "";
             this.uploadProgressaudio = 0;
             console.log('Audio permission granted');
             this.audioStart = true;
             this.fileName = new Date().getTime();
             this.recordFilePath = this.file.documentsDirectory + `${this.fileName}.m4a`;
             this.record = this.media.create(this.recordFilePath.replace(/file:\/\//g, ''));
             this.record.startRecord();
             this.showIcon = true;
             this.starttime();
             console.log("Record Start\"ios\"");
          } else {
            this.presentToast('Permission denied for media recording.');
            console.log('Audio permission denied');
          }
    }else {
          console.log("Platform not available");
    }
}
 checkAudioPermission(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    cordova.plugins.diagnostic.requestMicrophoneAuthorization(status => {
      if (status === cordova.plugins.diagnostic.permissionStatus.GRANTED) {
        resolve(true); 
      } else {
        resolve(false); 
      }
    }, error => {
      reject(error);
    });
  });
}


onUploadProgress(event) {
  if (event.type === HttpEventType.UploadProgress) {
    const percentage = Math.round((event.loaded * 100) / event.total);
    this.loaderpercentage = Math.round(event.loaded / event.loaded * 100);
    this.uploadProgress = Math.round((event.loaded * 100) / event.total);
    console.log(`Upload Progress: ${percentage}%`);
    console.log("typeof(this.uploadProgress)", typeof (this.uploadProgress));

  }
}
  audiofile : any;
  recordicon : any = true;
  
  stopRec() {
    this.audioStart = false;
    this.record.stopRecord();
    console.log(this.record)
    this.showIcon = false;
    this.reset()
    this.fileupload.uploadAudio(this.recordFilePath).then(async data => {
      console.log(data,"audio response");
      if (data[0] != '0') {
        this.audiofile = data;
      }
      console.log(data[0],"response for audio",this.audiofile);
      console.log('check provider ', this.fileupload.filepath);
      this.audioblob = data[0];
      this.recorded_audio();
    })    
  }
 
  gotoGallery(e:any) {
    if(e.target.files[0] != undefined && e.target.files[0] !=""){
    this.isDisable = false;
    this.uploadProgress = 0;
    this.PatientProfileImage = "";
  
    const formData = new FormData();
    formData.append('module_id', "66");
    formData.append('file', e.target.files[0]);
    formData.append('pathLocation', "SUPPORT/");
    const URL = this.services.apiURL() + "admin/awsS3FileUpload";

    this.http.post(URL, formData, {
      reportProgress: true, 
      observe: 'events',   
    }).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {
        this.uploadProgress = Math.round((100 * event.loaded) / event.total);
      } else if (event.type === HttpEventType.Response) {
        const response:any = event.body;
        console.log("Response from upload: ", response);  
        this.PatientProfileImage = response.filepath.Location;
        this.fileList.push(response.filepath.privatePathUrl);
        console.log("Uploaded file path: ", this.fileList);
        this.isDisable = true;
      }
    });
  }
  }
  
 recorded_audio(){
  this.isDisableAudio = false;
  this.uploadProgressaudio = 0;
    const formData = new FormData();
    formData.append('module_id', "66");
    formData.append('file', this.audioblob, "trsupaud.mp3");
    formData.append('pathLocation', "SUPPORT/");

    const URL = this.services.apiURL() + "admin/awsS3FileUpload";

    this.http.post(URL, formData, {
      reportProgress: true, 
      observe: 'events',   
    }).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {
        const percentage = Math.round((event.loaded * 100) / event.total);
        this.uploadProgressaudio = percentage;
        console.log(`Upload Progress: ${percentage}%`);
      } else if (event.type === HttpEventType.Response) {
        const data: any = event.body;
        if (data.filepath && data.filepath.Location) {
          console.log("Audio file uploaded to:", data.filepath.Location);
          this.audiodata = data.filepath.Location;
          this.audiopathdata = data.filepath.privatePathUrl;
          this.isDisableAudio = true;
        }
      }
    });
 }


 removeAudio(){ 
      this.showIcon = false;
      this.reset()
      this.audiofile = "";
      this.fileupload.filepath = "";
      this.recordicon = true;
      this.audiodata = 0;
      this.audiopathdata = "";
      this.uploadProgressaudio = 0;
      this.audioStart = false;
 }



goBack() {
   switch (this.backValue) {
      case "goHome": {
        this.router.navigate(['tabs/home']);
        break;
      }
      case "goListPage": {
        this.presentView = "listAskdReportsPage";
        this.backValue = "goHome";
       this.removeAudio();
      }
    }
   }
 
  removeFile(index) {
    this.fileList.splice(index, 1);
    this.fileupload.removeFile(index);
    console.log("Files Array -> ", this.fileList);
  }

 async select_program(){
  console.log(this.storeListModule,"sltprogram");
  let popup = await this.modalCtrl.create({
    component : SelectProgramPage,
    backdropDismiss: false,
    cssClass: 'service-model2sltpro',
    componentProps : {
      program : this.storeListModule
    }
  });
  popup.onDidDismiss().then((data) => {
    let date1 = data.data;
    console.log(data);
    this.getModule = date1;
  });
  await popup.present();
  }
}

